import { render, staticRenderFns } from "./BasePopup.vue?vue&type=template&id=67bdf528&scoped=true"
import script from "./BasePopup.vue?vue&type=script&lang=js"
export * from "./BasePopup.vue?vue&type=script&lang=js"
import style0 from "./BasePopup.vue?vue&type=style&index=0&id=67bdf528&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67bdf528",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67bdf528')) {
      api.createRecord('67bdf528', component.options)
    } else {
      api.reload('67bdf528', component.options)
    }
    module.hot.accept("./BasePopup.vue?vue&type=template&id=67bdf528&scoped=true", function () {
      api.rerender('67bdf528', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/global/BasePopup.vue"
export default component.exports